import { http, HttpResponse, PathParams } from 'msw';
import { AuthApiPaths } from '../../../slices/auth-api.slice';
import { apiUrl } from '../apiUrl';
import { contacts } from '../../data/contacts';
import { composeServerError, otpHandler, validateNewPassword, validateOtp } from './shared';
import { userEmail } from '../../data/userInfo';
import { recoverAccountOutput } from '../../data/recover-account';

// to read the body use an async handler
const resetPasswordVerifyTotpMutation = http.post<PathParams, { passcode: string }>(
    apiUrl(AuthApiPaths.resetPasswordVerifyTotp),
    async ({ request }) => {
        const body = await request.json();
        const error = validateOtp(body.passcode);
        return error ? composeServerError(request, error) : HttpResponse.json({ contacts });
    }
);
// send phone otp
const resetPasswordUserConsentForPhoneOtpMutation = http.post(
    apiUrl(AuthApiPaths.resetPasswordUserConsentForPhoneOtp),
    () => {
        return new HttpResponse();
    }
);

// verify phone top
const resetPasswordVerifyPhoneOTPMutation = http.post<PathParams, { passcode: string }>(
    apiUrl(AuthApiPaths.resetPasswordVerifyPhoneOTP),
    async ({ request }) => {
        const body = await request.json();
        const error = validateOtp(body.passcode);
        return error ? composeServerError(request, error) : new HttpResponse();
    }
);

// resend phone top
const resetPasswordResendPhoneOTPMutation = http.post(apiUrl(AuthApiPaths.resendPhoneOtp), () => {
    return new HttpResponse(); // status is 200 by default
});

// send email otp
const resetPasswordInitMutation = http.post<PathParams, { email: string }>(
    apiUrl(AuthApiPaths.resetPasswordInit),
    async ({ request }) => {
        const body = await request.json();
        const { email } = body;

        const retries = JSON.parse(sessionStorage.getItem('resetPasswordRetries') || '0');
        sessionStorage.setItem('resetPasswordRetries', JSON.stringify(retries + 1));

        if (retries && retries % 2 === 0) {
            return HttpResponse.json(undefined, { status: 429 });
        }

        if (email === userEmail) {
            return composeServerError(request, 'invalidEmailFormat');
        }
        return new HttpResponse();
    }
);

// verify email top
const resetPasswordSubmitOTPMutation = http.post(apiUrl(AuthApiPaths.resetPasswordSubmitOtp), otpHandler);

// resend email top
const resetPasswordResendOTPMutation = http.post(apiUrl(AuthApiPaths.resendEmailOtp), () => HttpResponse.json());

const resetPasswordMutation = http.post<PathParams, { password: string }>(
    apiUrl(AuthApiPaths.resetPassword),
    async ({ request }) => {
        const { password } = await request.json();
        const error = validateNewPassword(password);
        return error ? composeServerError(request, error) : HttpResponse.json();
    }
);

const recoverAccountMutation = http.post<PathParams, { recoverAccount: string }>(
    apiUrl(AuthApiPaths.recoverAccount),
    async () => {
        return HttpResponse.json(recoverAccountOutput);
    }
);

export const resetPasswordHandlers = [
    resetPasswordMutation,
    resetPasswordVerifyTotpMutation,
    resetPasswordUserConsentForPhoneOtpMutation,
    resetPasswordVerifyPhoneOTPMutation,
    resetPasswordResendPhoneOTPMutation,
    resetPasswordInitMutation,
    resetPasswordSubmitOTPMutation,
    resetPasswordResendOTPMutation,
    recoverAccountMutation
];
